import { AddAiModel, getActiveAiModel, getAllAimodels, getAllavailablemodel, updateAiModel } from "Config/API/get";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import './AssetChatbot.css';
import { aifileid, currentselectedfiledata } from "Redux/action/variable.action";
import { useDispatch } from "react-redux";

const AiModel = ({ onClose }) => {
  const [models, setModels] = useState([]);
  const [selectedModelId, setSelectedModelId] = useState(null);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");
const [selectedmodelprovider,setSelectedModelProvider]= useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [modelsRes] = await Promise.all([
          getAllavailablemodel(token),
        ]);
        if (modelsRes?.status) {
          setModels(modelsRes.data.models || []);
        }
    
      } catch (err) {
        console.error("Error fetching AI models", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token]);
  const dispatch = useDispatch();
  const handleUpdate = async () => {
    if (!selectedModelId) {
      toast.error("Please select a model first");
      return;
    }

    try {
      setLoading(true);
      const res = await AddAiModel(token,selectedModelId, selectedmodelprovider);
      if (res?.status) {
     
        toast.success("Model added successfully!");
        onClose();
      } else {
        toast.error(res?.message || "Failed to adding model");
      }
    } catch (err) {
      console.error("Error adding AI model", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="aiassistant-overlay" onClick={onClose}>
      <div className="aiassistant-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="aiassistant-title">ADD AI Model</h2>

        {loading ? (
          <div className="aiassistant-loading">
            <div className="spinner"></div>
          </div>
        ) : models.length > 0 ? (
          <div className="aiassistant-model-list">
            {models.map((model) => (
              <label key={model.id} className="aiassistant-model-item">
                <input
                  type="radio"
                  name="ai-model"
                  value={model.modal}
                  checked={selectedModelId === model.modal}
                  onChange={() => {setSelectedModelId(model.modal); setSelectedModelProvider(model.provider)}}
                />
                <div>
                  <p className="model-name">{model.modal}</p>
                  <p className="model-description">{model.provider}</p>
                </div>
              </label>
            ))}
          </div>
        ) : (
          <p className="no-models">ALL THE AVAILABLE MODALS ARE ALREADY ADDED</p>
        )}

{ models.length > 0 &&
        <div className="aiassistant-buttons">
          <button className="cancel-btn" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="update-btn" onClick={handleUpdate} disabled={loading}>
            {loading ? "Add" : "Add"}
          </button>
        </div>}
      </div>
    </div>
  );
};

export default AiModel;